module.exports = __webpack_public_path__ + "media/images/visa copy-91165ed4b4baaece0ab47dffafa1ad76.png";